export const MESSAGES = {
  FAILURE: {
    LOGIN: "LOGIN_FAILURE",
    REGISTER: "REGISTER_FAILURE",
  },

  SUCCESS: {
    REGISTER: "REGISTER_SUCCESS",
    SIGN_OUT: "SIGN_OUT_SUCCESS",
    LOGIN: "LOGIN_SUCCESS",
  },

  DETAILS: {
    USER: "USER_DETAILS",
    TOKEN_VALIDITY: "TOKEN_VALID_UNTIL"
  },

  PROMISE: {
    SUCCESS: "success",
    REJECT: "Registration failed",
  },
  INBOX: {
    UNREAD_COUNT: "SET_UNREAD_MESSAGES_COUNT"
  }
};
